// extracted by mini-css-extract-plugin
module.exports = {"LPPage":"GitLab_LPPage__1x35Y","contents":"GitLab_contents__1tGeq","contact_wrapper":"GitLab_contact_wrapper__3IzYk"};